import 'bootstrap/dist/css/bootstrap.min.css';
import './src/styles/fonts.css';

export const shouldUpdateScroll = ({ routerProps }) => {
  return false;
};
